export default "__VITE_ASSET__6466e793__"